import React from 'react';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import Modal from '../../../../../Components/Modal/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import PatientDataVerificationCSSZResult, {
	PatientDataVerificationCSSZResultExtra,
} from './PatientDataVerificationCSSZResult';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	extra: PatientDataVerificationCSSZResultExtra;
}

const PatientDataVerificationCSSZResultModal: React.FC<Props> = ({
	isOpen,
	onClose,
	extra,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.SM}>
			<Modal.Header title='component.patientDataVerificationCSSZResult.modalTitle' />
			<Modal.Content contentScroll>
				<PatientDataVerificationCSSZResult extra={extra} onClick={onClose} />
			</Modal.Content>
		</Modal>
	);
};

export default PatientDataVerificationCSSZResultModal;
